import React, { useState } from "react";
import {
  Grid2,
  Box,
  CardMedia,
  Typography,
  Button,
  Modal,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";

import sampleEvent from "../Images/sampleEvent.jpeg";
import Discover200Shop from "../Images/Discover200ShopSqBig.jpg";
import FirstUMC from "../Images/FirstUMCSqBig.jpg";
import BigCaF from "../Images/BigCaFSqBig.jpg";
import Ave5th from "../Images/5thAveSqBig.jpg";

import "../Styles/EventList.css";

const events = [
  {
    id: 0,
    title: "Discover 200 Alachua County Bicentennial Store",
    desc: "Stock up on all of your DISCOVER 200 merchandise to celebrate Alachua County's Bicentennial!",
    link: "https://9qrfay-n0.myshopify.com/collections/discover-200-alachua-county-store",
    image: Discover200Shop,
    srOnly:
      "about Discover 200 Alachua County Bicentennial Store (opens in new tab)",
    srImg: "Discover 200 Alachua County Bicentennial Store",
  },
  {
    id: 1,
    title: "Remember Hope Concert",
    time: "Saturday, March 29 at 7:00 p.m. at First United Methodist Church",
    desc: "Remember Hope is a concert sponsored by First UMC and others in our community celebrating the 200th anniversary of Alachua County",
    link: "https://fumcgnv.org/remember",
    image: FirstUMC,
    srOnly: "about Remember Hope Concert (opens in new tab)",
    srImg: "Remember Hope Concert flyer",
  },
  {
    id: 2,
    title: "Big: Cultural & Arts Festival",
    time: "April 11th and 12th in Downtown Gainesville, Florida.",
    desc: "Big: Cultural & Arts Festival is an unforgettable experience packed with music, art, and interactive entertainment for all ages.",
    link: "https://bigcaf.com/",
    image: BigCaF,
    srOnly: "about Big: Cultural & Arts Festival (opens in new tab)",
    srImg: "Big: Cultural & Arts Festival flyer",
  },
  {
    id: 3,
    title: "The Fifth Avenue Arts Festival",
    time: "May 17th and 18th in Gainesville, Florida.",
    desc: "The Fifth Avenue Arts Festival, organized annually by the Cultural Arts Coalition in Gainesville, Florida, is a vibrant celebration of art, culture, and community.",
    link: "https://www.culturalartscoalition.org/annual-5th-ave-arts-festival/",
    image: Ave5th,
    srOnly: "about The Fifth Avenue Arts Festival (opens in new tab)",
    srImg: "The Fifth Avenue Arts Festival flyer",
  },

  // Add more events as needed
];

const EventList = () => {
  const [openId, setOpenId] = useState(null); // Store the index of the clicked card

  // Handle image click to open modal
  const handleImageClick = (index) => {
    setOpenId(index);
  };

  // Close modal
  const handleClose = () => {
    setOpenId(null);
  };
  return (
    <div className="event-list-margins">
      <hr style={{ marginBottom: "15px" }} />
      <Grid2
        container
        spacing={1}
        direction="column"
        rowSpacing={{ xs: 1, xl: 4, xxl: 6 }}
      >
        {events.map((event) => (
          <Grid2 item xs={12} key={event.id}>
            <Grid2 container spacing={2} style={{ marginBottom: "10px" }}>
              {/* Left side: Image */}
              <Grid2
                item
                size={{ xs: 12, sm: 5, md: 4, lg: 4, xl: 3 }}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CardMedia
                  component="img"
                  image={event.image}
                  alt={event.title}
                  style={{
                    width: "60%",
                    height: "auto",
                    borderRadius: "10%",
                    maxHeight: "150px",
                    maxWidth: "150px",
                  }}
                  onClick={() => handleImageClick(event.id)} // Pass the index of the clicked card
                  aria-describedby="Click to enlarge the flyer image"
                />
              </Grid2>
              {/* Right side: Title, Time, and Link */}
              <Grid2 item size={{ xs: 12, sm: 7, md: 8, lg: 8, xl: 9 }}>
                <Typography variant="h6">{event.title}</Typography>
                <Typography variant="body2">
                  <b>{event.time}</b>
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {event.desc}
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  href={event.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginTop: "10px" }}
                  aria-describedby={event.srOnly}
                >
                  More Info
                  <Box sx={visuallyHidden}>{event.srOnly} </Box>
                  {/* <span className="sr-only">{event.srOnly}</span> */}
                </Button>
              </Grid2>
            </Grid2>
            <hr style={{ marginTop: "15px" }} />
          </Grid2>
        ))}
      </Grid2>

      {/* Modal to display the enlarged image */}
      <Modal
        open={openId !== null}
        onClose={handleClose}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            position: "relative",
          }}
        >
          <Button
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: -40,
              right: 0,
              zIndex: 1, // Ensures the button is above the image
              backgroundColor: "white",
              color: "black",
              "&:hover": {
                backgroundColor: "#009CDC",
              },
            }}
            aria-describedby="Close the enlarged flyer image"
          >
            Close
          </Button>
          <img
            src={events[openId]?.image} // Access the image directly from the index
            alt="Enlarged"
            style={{
              maxHeight: "80vh", // Set max height to 80% screen height
              maxWidth: "80vw", // Set max width to 80% screen width
              width: "auto", // Maintain the aspect ratio
              height: "auto", // Maintain the aspect ratio
              objectFit: "contain", // Ensure the image doesn't stretch
              borderRadius: "8px",
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default EventList;
